import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FaIcon } from 'client/js/util/layout_utils';
import { Modal, ModalHeader } from 'client/js/util/modal';
import { errorToToast } from 'client/js/util/rest_utils';
import React from 'react';
import { toast } from 'react-toastify';

const ZonefileModal = ({ domainId, domainFqdn, isOpen, onClose }) => {
  const [zoneContent, setZoneContent] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(true);
  const queryClient = useQueryClient();

  // Fetch zonefile when modal opens
  React.useEffect(() => {
    if (isOpen) {
      setIsLoading(true);
      $.ajax({
        url: `/usercp/domains/${domainId}/records/export_bind`,
        type: 'GET',
        dataType: 'text'
      })
        .done((data) => {
          setZoneContent(data);
          setIsLoading(false);
        })
        .fail((error) => {
          errorToToast(error, 'beim Laden der Zone-Datei');
          setIsLoading(false);
        });
    }
  }, [isOpen, domainId]);

  // Import mutation
  const { mutate: importZone, isLoading: isImporting } = useMutation({
    mutationFn: (content) => {
      return $.ajax({
        url: `/usercp/domains/${domainId}/records/import_bind`,
        type: 'POST',
        data: { zone_content: content },
        dataType: 'json'
      });
    },
    onSuccess: (data) => {
      toast.success(data.message || 'Zone erfolgreich importiert');
      queryClient.invalidateQueries({ queryKey: ['domain', domainId, 'dns_records'] });
      onClose();
    },
    onError: (error) => {
      errorToToast(error, 'beim Importieren der Zone-Datei');
    }
  });

  const handleSave = (e) => {
    e.preventDefault();
    importZone(zoneContent);
  };

  const handleDownload = (e) => {
    e.preventDefault();
    window.location.href = `/usercp/domains/${domainId}/records/export_bind`;
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} contentLabel="Zone-Datei" large>
      <ModalHeader title={`Zone-Datei für ${domainFqdn}`} onRequestClose={onClose} />

      <div className="modal-body">
        {isLoading ? (
          <div className="text-center py-5">
            <div className="css-spinloader"></div>
            <p className="mt-3">Zone-Datei wird geladen...</p>
          </div>
        ) : (
          <>
            <p className="text-muted">
              Du kannst die Zone-Datei hier bearbeiten und importieren. Es wird das Bind-Format unterstützt.
            </p>

            <textarea
              className="form-control font-monospace"
              rows="20"
              value={zoneContent}
              onChange={(e) => setZoneContent(e.target.value)}
              disabled={isImporting}
              style={{ fontSize: '12px' }}
            />

            <div className="mt-3">
              <a
                href="#"
                onClick={handleDownload}
                className="btn btn-sm btn-link"
              >
                <FaIcon name="download" /> Zone-Datei herunterladen
              </a>
            </div>
          </>
        )}
      </div>

      <div className="modal-footer">
        <button
          className="btn btn-secondary"
          onClick={onClose}
          disabled={isImporting}
        >
          <FaIcon name="times" /> Abbrechen
        </button>
        <button
          className="btn btn-primary"
          onClick={handleSave}
          disabled={isLoading || isImporting}
        >
          <FaIcon name="save" loading={isImporting} /> Speichern & Importieren
        </button>
      </div>
    </Modal>
  );
};

export default ZonefileModal;
